<template>
  <div class="load-more-box">
    <a-button
      v-if="hasMore"
      type="primary"
      :loading="loading"
      @click="handleLoadMore"
    >
      {{ loading ? '加载中...' : '加载更多' }}
    </a-button>
    <span v-else class="no-more">没有更多数据了</span>
  </div>
</template>

<script>
export default {
  name: 'LoadMorePagination',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: true
    },
    fn: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    handleLoadMore() {
      if (this.isLoading || this.loading) return
      this.isLoading = true
      this.fn()
      setTimeout(() => {
        this.isLoading = false
      }, 500)
    }
  }
}
</script>

<style lang="less" scoped>
.load-more-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  padding: 12px 0;

  .no-more {
    color: #999;
    font-size: 14px;
  }
}
</style>
